import { head, partition } from 'lodash/fp';

import { Bracket, Rate, Tier } from '../../../../../../../types/__codegen__/sanity/graphql';
import { Threshold } from '../../../../types';
import constants from '../../../../../../../ahm-constants';

const getThresholdsFromTaxRate = (activeTaxRate: Rate, incomeType: string | undefined): Threshold[] | null => {
  if (!activeTaxRate.brackets) return null;

  const { brackets } = activeTaxRate;
  const isSingleIncome = incomeType === constants.INCOME_TYPE.SINGLE;

  const [singlesBracket, couplesFamiliesBracket] = partition(
    (bracket: Bracket) => bracket?.bracketType?.name === 'Singles',
    brackets,
  );

  const activeBracket = head(isSingleIncome ? singlesBracket : couplesFamiliesBracket) as Bracket;

  return (activeBracket.tiers ?? [])
    .filter((tier): tier is Tier => tier != null)
    .map((tier: Tier) => ({
      max: tier.tierMaximum ?? Infinity,
      min: tier.tierMinimum ?? 0,
      rate: tier.rate ?? 0,
    }));
};

export default getThresholdsFromTaxRate;
